var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0311 9.84417C15.4686 12.6567 13.348 15.3049 10.3723 15.8967C8.92106 16.1857 7.41561 16.0095 6.07033 15.3931C4.72505 14.7768 3.60851 13.7517 2.87971 12.4638C2.1509 11.176 1.84698 9.69104 2.01122 8.22043C2.17546 6.74981 2.79949 5.3685 3.79445 4.27317C5.8352 2.02542 9.28107 1.40667 12.0936 2.53167",
    stroke: "white",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 8.71875L9.28125 11.5312L16.0312 4.21875",
    stroke: "white",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.0edb35874ec7def27d1115ed48f696ab.svg";
export { ForwardRef as ReactComponent };